import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="pt-32 pb-24 bg-white">
      <div className="mx-auto max-w-2xl px-4 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#C6A35B]">404</p>
        <h1 className="mt-3 font-display text-5xl font-semibold text-[#144726]">Page not found</h1>
        <p className="mt-4 text-slate-600">The page you’re looking for has moved or no longer exists.</p>
        <Link to="/"><Button className="mt-8 bg-[#144726] text-white hover:bg-[#0E3520]"><ArrowLeft className="mr-2 h-4 w-4" /> Back to home</Button></Link>
      </div>
    </div>
  );
}
